export interface RazorpaySubscriptionResponse {
  razorpay_payment_id: string;
  razorpay_subscription_id: string;
  razorpay_signature: string;
}

interface RazorpaySubscriptionOptions {
  key: string;
  subscription_id: string;
  name: string;
  description: string;
  prefill: {
    email?: string;
    name?: string;
  };
  theme: {
    color: string;
  };
  handler: (response: RazorpaySubscriptionResponse) => void;
  modal: {
    ondismiss: () => void;
  };
}

interface RazorpayConstructor {
  new (options: RazorpaySubscriptionOptions): { open: () => void };
}

interface RazorpayWindow extends Window {
  Razorpay: RazorpayConstructor;
}

export const openRazorpaySubscriptionCheckout = (
  options: RazorpaySubscriptionOptions
): void => {
  const rzpWindow = window as unknown as RazorpayWindow;
  if (!rzpWindow.Razorpay) {
    throw new Error("Razorpay checkout script not loaded");
  }
  const rzp = new rzpWindow.Razorpay(options);
  rzp.open();
};
